import * as React from 'react';

const SignsSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="signs_svg__eds-icon--signs_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="signs_svg__eds-icon--signs_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 13h1V7h5v8h-6v-2zM3 12h12V4H3v8zM2 3v10h6.5v8h1v-8H14v3h3.5v5h1v-5H22V6h-6V3H2z"
        />
        <path
            id="signs_svg__eds-icon--signs_line_1_"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 9h8v1H5z"
        />
        <path
            id="signs_svg__eds-icon--signs_line"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 6h8v1H5z"
        />
    </svg>
);

SignsSvg.displayName = 'SignsSvg';
export default SignsSvg;
